<i18n>
{
	"en": {
		"searchOrder": "Search order"
	},
	"no": {
		"searchOrder": "Søk oppdrag"
	}
}
</i18n>
<template>
	<t-text-input
		v-model="orderSearchInput"
		:placeholder="$t('searchOrder')"
		@keydown.enter="onEnter"
	/>
</template>

<script>
import { eventBus } from '@/core';

export default {
	name: 'OrderSearchInput',
	props: {
		needReroute: Boolean,
	},
	data() {
		return {
			orderSearchInput: '',
			orderSearchTimeout: undefined
		};
	},
	methods: {
		onEnter(event) {
			event.preventDefault();
			event.stopPropagation();
			if (!this.orderSearchInput || this.orderSearchInput === '') return;
			clearTimeout(this.orderSearchTimeout);
			this.orderSearchTimeout = setTimeout(() => {
				this.openEditOrder();
			}, 100);
		},
		openEditOrder() {
			if (this.needReroute) {
				this.$router.push({ name: 'operational' }).then(() => {
					eventBus.queue('setEditOrderByQuickSearch', this.orderSearchInput);
				});
			} else {
				eventBus.queue('setEditOrderByQuickSearch', this.orderSearchInput);
			}
		}
	}
};
</script>
